import { useMutation } from 'react-query';
import { network } from 'services/network';

const setKeyActivitiesTags = (params) => {
    return network
        .post('api/bo/setKeyActivitiesTags', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useMutationsSetKeyActivitiesTags = () => {
    return useMutation<any, QueryError, unknown>((params) => setKeyActivitiesTags(params));
};
